import { H1, Text } from '@betterment/samba-react';

import { ErrorContent } from '../error-content/ErrorContent';

const NotFound = () => (
  <ErrorContent>
    <ErrorContent.Image />
    <ErrorContent.Header>
      <H1>Not Found</H1>
    </ErrorContent.Header>
    <ErrorContent.Description>
      <Text>The page you're looking for isn’t here. Sorry about that.</Text>
    </ErrorContent.Description>
  </ErrorContent>
);

export default NotFound;
